import svgPaths from "./svg-0a6zn4hic0";

function Frame() {
  return (
    <div className="absolute left-[2px] size-[20px] top-[2px]" data-name="Frame">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <g id="Frame">
          <path d={svgPaths.p809180} id="Vector" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
          <path d={svgPaths.p362df000} id="Vector_2" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
          <path d={svgPaths.p67ef620} id="Vector_3" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        </g>
      </svg>
    </div>
  );
}

export default function Corner() {
  return (
    <div className="overflow-clip relative rounded-[4px] size-full" data-name="Corner">
      <Frame />
    </div>
  );
}
